// import React, { useState } from 'react';
// import { useQuery } from 'react-query';
// import axios from 'axios';
// import {
//   Box,
//   Spinner,
//   Text,
//   Image,
//   VStack,
//   Heading,
//   Badge,
//   Alert,
//   AlertIcon,
//   Container,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalCloseButton,
//   ModalBody,
//   ModalFooter,
//   Button,
// } from '@chakra-ui/react';
// import Api from '../../../api/ApiUrl';

// const API_URL = `${Api}/api/v1`;
// const fetchPaymentData = async () => {
//   const { data } = await axios.get(`${API_URL}/payments/getprocessPayment`);
//   return data.data.data; // Returning the entire array of data
// };

// const PaymentDetails = () => {
//   const { data, isLoading, isError, error } = useQuery({
//     queryKey: ['paymentData'],
//     queryFn: fetchPaymentData,
//   });

//   const [selectedImage, setSelectedImage] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const handleImageClick = (imageSrc) => {
//     setSelectedImage(imageSrc);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedImage(null);
//   };

//   if (isLoading) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
//         <Spinner size="xl" color="teal.500" />
//       </Box>
//     );
//   }

//   if (isError) {
//     return (
//       <Alert status="error" bg="red.600" color="white">
//         <AlertIcon />
//         {error.message || 'Error fetching data'}
//       </Alert>
//     );
//   }

//   return (
//     <Container maxW="container.xl" py={10}>
//       <VStack spacing={6} align="start" width="100%">
//         <Heading as="h2" size="lg" color="teal.400">
//           Payment Details
//         </Heading>
//         <Table variant="striped" colorScheme="teal" size="sm">
//           <Thead>
//             <Tr>
//               <Th>Billing Method</Th>
//               <Th>Status</Th>
//               {/* <Th>Winner ID</Th> */}
//               <Th>User Name</Th>
//               <Th>User Phone</Th>
//               <Th>Subcategory Name</Th>
//               <Th>Category Name</Th>
//               <Th>Total Amount</Th>
//               <Th>Bill Image</Th>
//               <Th>Created At</Th>
//               <Th>Updated At</Th>
//               <Th>Results</Th>
//             </Tr>
//           </Thead>
//           <Tbody>
//             {data.map((payment) => (
//               <React.Fragment key={payment._id}>
//                 <Tr>
//                   <Td>
//                     <Badge colorScheme="blue">{payment.billingMethod}</Badge>
//                   </Td>
//                   <Td>
//                     <Badge colorScheme={payment.status === 'pending' ? 'orange' : 'green'}>
//                       {payment.status}
//                     </Badge>
//                   </Td>
//                   {/* <Td>{payment.winnerid?._id}</Td> */}
//                   <Td>{payment.winnerid?.userId?.name}</Td>
//                   <Td>{payment.winnerid?.userId?.phoneNumber}</Td>
//                   <Td>{payment.winnerid?.subcategory?.name}</Td>
//                   <Td>{payment.winnerid?.subcategory?.categoryId?.name}</Td>
//                   <Td>{payment.winnerid?.totalAmount}</Td>
//                   <Td>
//                     <Image
//                       src={`${Api}/${payment.billImage?.path}`}
//                       alt={payment.billImage?.name}
//                       boxSize="50px"
//                       objectFit="cover"
//                       cursor="pointer"
//                       onClick={() => handleImageClick(`${Api}/${payment.billImage?.path}`)}
//                     />
//                   </Td>
//                   <Td>{new Date(payment.createdAt).toLocaleString()}</Td>
//                   <Td>{new Date(payment.updatedAt).toLocaleString()}</Td>
//                   <Td>
//                     {payment.winnerid?.results.map((result) => (
//                       <Box key={result._id} mb={2}>
//                         {/* <Text fontWeight="bold">Result ID: {result._id}</Text> */}
//                         <Text>User Name: {result.userId?.name}</Text>
//                         <Text>User Phone: {result.userId?.phoneNumber}</Text>
//                         <Text>Item Name: {result.itemId?.name}</Text>
//                         <Text>Amount: {result.amount}</Text>
//                         <Text>Status: {result.status}</Text>
//                         {/* <Text>Timestamp: {new Date(result.timestamp).toLocaleString()}</Text> */}
//                       </Box>
//                     ))}
//                   </Td>
//                 </Tr>
//               </React.Fragment>
//             ))}
//           </Tbody>
//         </Table>

//         {/* Modal to display the clicked image */}
//         <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
//           <ModalOverlay />
//           <ModalContent>
//             <ModalHeader>Bill Image</ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//               {selectedImage && (
//                 <Image src={selectedImage} alt="Bill Image" boxSize="100%" objectFit="cover" />
//               )}
//             </ModalBody>
//             <ModalFooter>
//               <Button colorScheme="teal" onClick={handleCloseModal}>
//                 Close
//               </Button>
//             </ModalFooter>
//           </ModalContent>
//         </Modal>
//       </VStack>
//     </Container>
//   );
// };

// export default PaymentDetails;








// import React, { useState } from 'react';
// import { useQuery, useMutation } from 'react-query';
// import axios from 'axios';
// import {
//   Box,
//   Spinner,
//   Text,
//   Image,
//   VStack,
//   Heading,
//   Badge,
//   Alert,
//   AlertIcon,
//   Container,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalCloseButton,
//   ModalBody,
//   ModalFooter,
//   Button,
//   HStack,
// } from '@chakra-ui/react';
// import Api from '../../../api/ApiUrl';
// import CustomSpinner from './../../EndedAuctions/CustomSpinner';

// const API_URL = `${Api}/api/v1`;
// const fetchPaymentData = async () => {
//   const { data } = await axios.get(`${API_URL}/payments/getprocessPayment`);
//   return data.data.data; // Returning the entire array of data
// };

// const PaymentDetails = () => {
//   const { data, isLoading, isError, error } = useQuery({
//     queryKey: ['paymentData'],
//     queryFn: fetchPaymentData,
//   });

//   const [selectedImage, setSelectedImage] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const approvePaymentMutation = useMutation(async ({ paymentId, action }) => {
//     return axios.post(`${API_URL}/payments/admin/approve-payment`, { paymentId, action });
//   });

//   const handleImageClick = (imageSrc) => {
//     setSelectedImage(imageSrc);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedImage(null);
//   };

//   const handleApprove = (paymentId) => {
//     approvePaymentMutation.mutate({ paymentId, action: 'approve' });
//   };

//   const handleReject = (paymentId) => {
//     approvePaymentMutation.mutate({ paymentId, action: 'reject' });
//   };

//   if (isLoading) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
//         <CustomSpinner size="xl" color="teal.500" />
//       </Box>
//     );
//   }

//   if (isError) {
//     return (
//       <Alert status="error" bg="red.600" color="white">
//         <AlertIcon />
//         {error.message || 'Error fetching data'}
//       </Alert>
//     );
//   }

//   return (
//     <Container maxW="container.xl" py={10}>
//       <VStack spacing={6} align="start" width="100%">
//         <Heading as="h2" size="lg" color="teal.400">
//           Payment Details ({data.length} Payments)
//         </Heading>
//         <Table variant="striped" colorScheme="teal" size="sm">
//           <Thead>
//             <Tr>
//               <Th>#</Th>
//               <Th>Billing Method</Th>
//               {/* <Th>Status</Th> */}
//               {/* <Th>Winner ID</Th> */}
//               <Th>User Name</Th>
//               <Th>User Phone</Th>
//               <Th>Auction Name</Th>
//               <Th>Category Name</Th>
//               <Th>Total Amount</Th>
//               <Th>Bill Image</Th>
//               <Th>Created At</Th>
//               <Th>Updated At</Th>
//               {/* <Th>Actions</Th> */}
//               <Th>Results</Th>
//             </Tr>
//           </Thead>
//           <Tbody>
//             {data.map((payment, index) => (
//               <React.Fragment key={payment._id}>
//                 <Tr>
//                   <Td>{index + 1}</Td>
//                   <Td>
//                     <Badge colorScheme="blue">{payment.billingMethod}</Badge>
//                   </Td>
//                   {/* <Td>
//                     <Badge colorScheme={payment.status === 'pending' ? 'orange' : 'green'}>
//                       {payment.status}
//                     </Badge>
//                   </Td> */}
//                   {/* <Td>{payment.winnerid?._id}</Td> */}
//                   <Td>{payment.winnerid?.userId?.name}</Td>
//                   <Td>{payment.winnerid?.userId?.phoneNumber}</Td>
//                   <Td>{payment.winnerid?.subcategory?.name}</Td>
//                   <Td>{payment.winnerid?.subcategory?.categoryId?.name}</Td>
//                   <Td>{payment.winnerid?.totalAmount}</Td>
//                   <Td>
//                     <Image
//                       src={`${Api}/${payment.billImage?.path}`}
//                       alt={payment.billImage?.name}
//                       boxSize="50px"
//                       objectFit="cover"
//                       cursor="pointer"
//                       onClick={() => handleImageClick(`${Api}/${payment.billImage?.path}`)}
//                     />
//                   </Td>
//                   <Td>{new Date(payment.createdAt).toLocaleString()}</Td>
//                   <Td>{new Date(payment.updatedAt).toLocaleString()}</Td>
//                   {/* <Td>
//                     {payment.status === 'pending' && (
//                       <HStack spacing={2}>
//                         <Button
//                           colorScheme="green"
//                           size="xs"
//                           onClick={() => handleApprove(payment._id)}
//                           isLoading={approvePaymentMutation.isLoading}
//                         >
//                           Approve
//                         </Button>
//                         <Button
//                           colorScheme="red"
//                           size="xs"
//                           onClick={() => handleReject(payment._id)}
//                           isLoading={approvePaymentMutation.isLoading}
//                         >
//                           Reject
//                         </Button>
//                       </HStack>
//                     )}
//                   </Td> */}
//                   <Td>
//                     {payment.winnerid?.results.map((result) => (
//                       <Box key={result._id} mb={2}>
//                         {/* <Text fontWeight="bold">Result ID: {result._id}</Text> */}
//                         <Text>User Name: {result.userId?.name}</Text>
//                         <Text>User Phone: {result.userId?.phoneNumber}</Text>
//                         <Text>Lot Name: {result.itemId?.name}</Text>
//                         <Text>Amount: {result.amount}</Text>
//                         <Text>Status: {result.status}</Text>
//                         {/* <Text>Timestamp: {new Date(result.timestamp).toLocaleString()}</Text> */}
//                       </Box>
//                     ))}
//                   </Td>
//                 </Tr>
//               </React.Fragment>
//             ))}
//           </Tbody>
//         </Table>

//         {/* Modal to display the clicked image */}
//         <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
//           <ModalOverlay />
//           <ModalContent>
//             <ModalHeader>Bill Image</ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//               {selectedImage && (
//                 <Image src={selectedImage} alt="Bill Image" boxSize="100%" objectFit="cover" />
//               )}
//             </ModalBody>
//             <ModalFooter>
//               <Button colorScheme="teal" onClick={handleCloseModal}>
//                 Close
//               </Button>
//             </ModalFooter>
//           </ModalContent>
//         </Modal>
//       </VStack>
//     </Container>
//   );
// };

// export default PaymentDetails;




















// import React, { useState } from 'react';
// import { useQuery, useMutation } from 'react-query';
// import axios from 'axios';
// import {
//   Box,
//   Spinner,
//   Text,
//   Image,
//   VStack,
//   Heading,
//   Badge,
//   Alert,
//   AlertIcon,
//   Container,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalCloseButton,
//   ModalBody,
//   ModalFooter,
//   Button,
//   HStack,
//   Input,
//   Textarea,
//   useToast,
// } from '@chakra-ui/react';
// import Api from '../../../api/ApiUrl';
// import CustomSpinner from './../../EndedAuctions/CustomSpinner';

// const API_URL = `${Api}/api/v1`;
// const fetchPaymentData = async () => {
//   const { data } = await axios.get(`${API_URL}/payments/getprocessPayment`);
//   return data.data.data;
// };

// const PaymentDetails = () => {
//   const toast = useToast();
//   const { data, isLoading, isError, error, refetch } = useQuery('paymentData', fetchPaymentData);

//   const [selectedImage, setSelectedImage] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedPaymentId, setSelectedPaymentId] = useState(null);
//   const [reasonForRejection, setReasonForRejection] = useState('');
//   const [approveMessage, setApproveMessage] = useState(''); // Message before approving
//   const [phoneSearch, setPhoneSearch] = useState('');
//   const [isApproveModalOpen, setIsApproveModalOpen] = useState(false); // Modal for approve message
//   const [isResultsModalOpen, setIsResultsModalOpen] = useState(false); // Modal for showing results
//   const [selectedResults, setSelectedResults] = useState([]); // To store results for viewing

//   const approvePaymentMutation = useMutation(async ({ paymentId, action, message }) => {
//     return axios.post(`${API_URL}/payments/admin/approve-payment`, { paymentId, action, message });
//   }, {
//     onSuccess: (data) => {
//       toast({
//         title: `Payment ${data?.data?.action === 'approve' ? 'approved' : 'rejected'} successfully.`,
//         status: 'success',
//         duration: 3000,
//         isClosable: true,
//       });
//       refetch();
//       setIsApproveModalOpen(false);
//       setIsModalOpen(false);
//     },
//     onError: () => {
//       toast({
//         title: "Error performing action.",
//         status: "error",
//         duration: 3000,
//         isClosable: true,
//       });
//     }
//   });

//   const handleImageClick = (imageSrc) => {
//     setSelectedImage(imageSrc);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedImage(null);
//   };

//   const handleApprove = (paymentId) => {
//     setSelectedPaymentId(paymentId);
//     setIsApproveModalOpen(true);
//   };

//   const handleConfirmApprove = () => {
//     approvePaymentMutation.mutate({ paymentId: selectedPaymentId, action: 'approve', message: approveMessage });
//     setApproveMessage(''); // Clear message after approval
//   };

//   const handleReject = () => {
//     if (reasonForRejection.trim()) {
//       approvePaymentMutation.mutate({ paymentId: selectedPaymentId, action: 'reject', message: reasonForRejection });
//       setReasonForRejection('');
//       setSelectedPaymentId(null);
//     }
//   };

//   const handleOpenRejectModal = (paymentId) => {
//     setSelectedPaymentId(paymentId);
//     setIsModalOpen(true);
//   };

//   const handleViewResults = (results) => {
//     setSelectedResults(results);
//     setIsResultsModalOpen(true);
//   };

//   const filteredData = data?.filter(payment =>
//     payment.winnerid?.userId?.phoneNumber.includes(phoneSearch)
//   );

//   if (isLoading) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
//         <CustomSpinner size="xl" color="teal.500" />
//       </Box>
//     );
//   }

//   if (isError) {
//     return (
//       <Alert status="error" bg="red.600" color="white">
//         <AlertIcon />
//         {error.message || 'Error fetching data'}
//       </Alert>
//     );
//   }

//   return (
//     <Container maxW="container.xl" py={10}>
//       <VStack spacing={6} align="start" width="100%">
//         <Heading as="h2" size="lg" color="teal.400">
//           Payment Details ({filteredData.length} Payments)
//         </Heading>

//         {/* Search input for filtering by phone number */}
//         <Box width="100%" mb={4}>
//           <Input
//             placeholder="Search by phone number"
//             value={phoneSearch}
//             onChange={(e) => setPhoneSearch(e.target.value)}
//             size="md"
//             width="300px"
//           />
//         </Box>

//         <Table variant="striped" colorScheme="teal" size="sm">
//           <Thead>
//             <Tr>
//               <Th>#</Th>
//               <Th>Billing Method</Th>
//               <Th>User Name</Th>
//               <Th>User Phone</Th>
//               <Th>Auction Name</Th>
//               <Th>Category Name</Th>
//               <Th>Total Amount</Th>
//               <Th>Bill Image</Th>
//               <Th>Created At</Th>
//               <Th>Updated At</Th>
//               <Th>Results</Th>
//               <Th>Actions</Th>
//             </Tr>
//           </Thead>
//           <Tbody>
//             {filteredData.map((payment, index) => (
//               <Tr key={payment._id}>
//                 <Td>{index + 1}</Td>
//                 <Td>
//                   <Badge colorScheme="blue">{payment.billingMethod}</Badge>
//                 </Td>
//                 <Td>{payment.winnerid?.userId?.name}</Td>
//                 <Td>{payment.winnerid?.userId?.phoneNumber}</Td>
//                 <Td>{payment.winnerid?.subcategory?.name}</Td>
//                 <Td>{payment.winnerid?.subcategory?.categoryId?.name}</Td>
//                 <Td>{payment.winnerid?.totalAmount}</Td>
//                 <Td>
//                   <Image
//                     src={`${Api}/${payment.billImage?.path}`}
//                     alt={payment.billImage?.name}
//                     boxSize="50px"
//                     objectFit="cover"
//                     cursor="pointer"
//                     onClick={() => handleImageClick(`${Api}/${payment.billImage?.path}`)}
//                   />
//                 </Td>
//                 <Td>{new Date(payment.createdAt).toLocaleString()}</Td>
//                 <Td>{new Date(payment.updatedAt).toLocaleString()}</Td>
//                 <Td>
//                   <Button size="xs" onClick={() => handleViewResults(payment.winnerid?.results)}>
//                     View Results
//                   </Button>
//                 </Td>
//                 <Td>
//                   <HStack spacing={2}>
//                     <Button
//                       colorScheme="green"
//                       size="xs"
//                       onClick={() => handleApprove(payment._id)}
//                     >
//                       Approve
//                     </Button>
//                     <Button
//                       colorScheme="red"
//                       size="xs"
//                       onClick={() => handleOpenRejectModal(payment._id)}
//                     >
//                       Reject
//                     </Button>
//                   </HStack>
//                 </Td>
//               </Tr>
//             ))}
//           </Tbody>
//         </Table>

//         {/* Modal for viewing bill image */}
//         <Modal isOpen={isModalOpen && selectedImage} onClose={handleCloseModal}>
//           <ModalOverlay />
//           <ModalContent>
//             <ModalHeader>Bill Image</ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//               {selectedImage && (
//                 <Image src={selectedImage} alt="Bill Image" boxSize="100%" objectFit="cover" />
//               )}
//             </ModalBody>
//             <ModalFooter>
//               <Button colorScheme="teal" onClick={handleCloseModal}>
//                 Close
//               </Button>
//             </ModalFooter>
//           </ModalContent>
//         </Modal>

//         {/* Modal for rejection reason */}
//         <Modal isOpen={isModalOpen && selectedPaymentId && !selectedImage} onClose={handleCloseModal}>
//           <ModalOverlay />
//           <ModalContent>
//             <ModalHeader>Reject Payment</ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//               <Text mb={4}>Please provide a reason for rejection:</Text>
//               <Textarea
//                 placeholder="Enter reason for rejection..."
//                 value={reasonForRejection}
//                 onChange={(e) => setReasonForRejection(e.target.value)}
//               />
//             </ModalBody>
//             <ModalFooter>
//               <Button colorScheme="red" onClick={handleReject} isLoading={approvePaymentMutation.isLoading}>
//                 Submit Rejection
//               </Button>
//               <Button variant="ghost" onClick={handleCloseModal}>
//                 Cancel
//               </Button>
//             </ModalFooter>
//           </ModalContent>
//         </Modal>

//         {/* Modal for approve confirmation with message */}
//         <Modal isOpen={isApproveModalOpen} onClose={() => setIsApproveModalOpen(false)}>
//           <ModalOverlay />
//           <ModalContent>
//             <ModalHeader>Approve Payment</ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//               <Text mb={4}>Please provide a message for the approval:</Text>
//               <Textarea
//                 placeholder="Enter your message..."
//                 value={approveMessage}
//                 onChange={(e) => setApproveMessage(e.target.value)}
//               />
//             </ModalBody>
//             <ModalFooter>
//               <Button colorScheme="green" onClick={handleConfirmApprove} isLoading={approvePaymentMutation.isLoading}>
//                 Approve
//               </Button>
//               <Button variant="ghost" onClick={() => setIsApproveModalOpen(false)}>
//                 Cancel
//               </Button>
//             </ModalFooter>
//           </ModalContent>
//         </Modal>

//         {/* Modal for viewing results */}
//         <Modal isOpen={isResultsModalOpen} onClose={() => setIsResultsModalOpen(false)}>
//           <ModalOverlay />
//           <ModalContent>
            // <ModalHeader>Results</ModalHeader>
            // <ModalCloseButton />
            // <ModalBody>
            //   {selectedResults.length > 0 ? (
            //     selectedResults.map((result) => (
            //       <Box key={result._id} mb={4}>
            //         <Text><strong>User Name:</strong> {result.userId?.name}</Text>
            //         <Text><strong>User Phone:</strong> {result.userId?.phoneNumber}</Text>
            //         <Text><strong>Lot Name:</strong> {result.itemId?.name}</Text>
            //         <Text><strong>Amount:</strong> {result.amount}</Text>
            //         <Text><strong>Status:</strong> {result.status}</Text>
            //       </Box>
            //     ))
            //   ) : (
            //     <Text>No results available</Text>
            //   )}
            // </ModalBody>
            // <ModalFooter>
//               <Button colorScheme="teal" onClick={() => setIsResultsModalOpen(false)}>
//                 Close
//               </Button>
//             </ModalFooter>
//           </ModalContent>
//         </Modal>
//       </VStack>
//     </Container>
//   );
// };

// export default PaymentDetails;





















import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import axios from 'axios';
import {
  Box, Spinner, Text, VStack, Heading, Badge, Alert, AlertIcon, Container, Table, Thead, Tbody, Tr, Th, Td, Modal,
  ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Button, HStack, Input, Textarea, Image, useToast,
} from '@chakra-ui/react';
import Api from '../../../api/ApiUrl';
import CustomSpinner from './../../EndedAuctions/CustomSpinner';

const API_URL = `${Api}/api/v1`;

// Fetch payment data from the backend
const fetchPaymentData = async () => {
  const { data } = await axios.get(`${API_URL}/payments/getprocessPayment`);
  return data.data.data;
};

const PaymentDetails = () => {
  const toast = useToast();
  const { data, isLoading, isError, error, refetch } = useQuery('paymentData', fetchPaymentData);
  const [selectedPaymentId, setSelectedPaymentId] = useState(null);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [approveMessage, setApproveMessage] = useState('');
  const [reasonForRejection, setReasonForRejection] = useState('');
  const [phoneSearch, setPhoneSearch] = useState('');
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [isResultsModalOpen, setIsResultsModalOpen] = useState(false);
  const [selectedResults, setSelectedResults] = useState([]);

  // Mutation to approve or reject a payment
  const approvePaymentMutation = useMutation(
    async ({ paymentId, action, message }) => axios.post(`${API_URL}/payments/admin/approve-payment`, { paymentId, action, message }),
    {
      onSuccess: (data) => {
        toast({
          title: `Payment ${data?.data?.action === 'approve' ? 'approved' : 'rejected'} successfully.`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        refetch();  // Refetch data after success
        setIsApproveModalOpen(false);
        setIsRejectModalOpen(false);
      },
      onError: () => {
        toast({
          title: 'Error performing action.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    }
  );

  // Handle approve button click
  const handleApprove = (paymentId) => {
    setSelectedPaymentId(paymentId);
    setIsApproveModalOpen(true);
  };

  // Handle reject button click
  const handleReject = (paymentId) => {
    setSelectedPaymentId(paymentId);
    setIsRejectModalOpen(true);
  };

  // Handle viewing results for a specific payment
  const handleViewResults = (results) => {
    setSelectedResults(results);
    setIsResultsModalOpen(true);
  };

  // Confirm approval with a message
  const handleConfirmApprove = () => {
    approvePaymentMutation.mutate({ paymentId: selectedPaymentId, action: 'approve', message: approveMessage });
    setApproveMessage('');  // Clear the message after approving
  };

  // Confirm rejection with a reason
  const handleConfirmReject = () => {
    approvePaymentMutation.mutate({ paymentId: selectedPaymentId, action: 'reject', message: reasonForRejection });
    setReasonForRejection('');  // Clear the reason after rejecting
  };

  // Filter payments based on phone number
  const filteredData = data?.filter(payment => payment.winnerid?.userId?.phoneNumber.includes(phoneSearch));

  // Show loading spinner when data is loading
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CustomSpinner size="xl" color="teal.500" />
      </Box>
    );
  }

  // Show error message if there is an error fetching data
  if (isError) {
    return (
      <Alert status="error" bg="red.600" color="white">
        <AlertIcon />
        {error.message || 'Error fetching data'}
      </Alert>
    );
  }

  return (
    <Container maxW="container.xl" py={10}>
      <VStack spacing={6} align="start" width="100%">
        <Heading as="h2" size="lg" color="teal.400">
          Payment Details ({filteredData?.length} Payments)
        </Heading>

        {/* Search by phone number */}
        <Box width="100%" mb={4}>
          <Input
            placeholder="Search by phone number"
            value={phoneSearch}
            onChange={(e) => setPhoneSearch(e.target.value)}
            size="md"
            width="300px"
          />
        </Box>

        {/* Payment details table */}
        <Table variant="striped" colorScheme="teal" size="sm">
          <Thead>
            <Tr>
              <Th>#</Th>
              <Th>Billing Method</Th>
              <Th>User Name</Th>
              <Th>User Phone</Th>
              <Th>Auction Name</Th>
              <Th>Category Name</Th>
              <Th>Total Amount</Th>
              <Th>Status</Th>
              <Th>Bill Image</Th>
              <Th>Results</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredData.map((payment, index) => (
              <Tr key={payment._id}>
                <Td>{index + 1}</Td>
                <Td><Badge colorScheme="blue">{payment.billingMethod}</Badge></Td>
                <Td>{payment.winnerid?.userId?.name}</Td>
                <Td>{payment.winnerid?.userId?.phoneNumber}</Td>
                <Td>{payment.winnerid?.subcategory?.name}</Td>
                <Td>{payment.winnerid?.subcategory?.categoryId?.name}</Td>
                <Td color={'green'}>{payment.winnerid?.totalAmount}</Td>

                {/* Display payment status */}
                <Td>  <Badge colorScheme={
    payment.status === 'pending' 
      ? 'yellow' 
      : payment.status === 'rejected' 
      ? 'red' 
      : 'green'
  }>
    {payment.status}
  </Badge></Td>

                {/* Display bill image */}
                <Td>
                  {payment.billImage ? (
                    <Image
                      src={`${Api}/${payment.billImage?.path}`}
                      alt={payment.billImage?.name}
                      boxSize="50px"
                      objectFit="cover"
                      cursor="pointer"
                    />
                  ) : 'No Image'}
                </Td>

                {/* Button to view results */}
                <Td>
                  <Button size="xs" onClick={() => handleViewResults(payment.winnerid?.results)}>
                    View Results
                  </Button>
                </Td>

                {/* Show actions only if payment status is pending */}
                <Td>
                  {payment.status === 'pending' && (
                    <HStack spacing={2}>
                      <Button
                        colorScheme="green"
                        size="xs"
                        onClick={() => handleApprove(payment._id)}
                        isDisabled={approvePaymentMutation.isLoading}
                      >
                        Approve
                      </Button>

                      <Button
                        colorScheme="red"
                        size="xs"
                        onClick={() => handleReject(payment._id)}
                        isDisabled={approvePaymentMutation.isLoading}
                      >
                        Reject
                      </Button>
                    </HStack>
                  )}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>

        {/* Modal for approval confirmation */}
        <Modal isOpen={isApproveModalOpen} onClose={() => setIsApproveModalOpen(false)}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Approve Payment</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text mb={4}>Please provide a message for the approval:</Text>
              <Textarea
                placeholder="Enter your message..."
                value={approveMessage}
                onChange={(e) => setApproveMessage(e.target.value)}
              />
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="green" onClick={handleConfirmApprove} isLoading={approvePaymentMutation.isLoading}>
                Approve
              </Button>
              <Button variant="ghost" onClick={() => setIsApproveModalOpen(false)}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Modal for rejection confirmation */}
        <Modal isOpen={isRejectModalOpen} onClose={() => setIsRejectModalOpen(false)}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Reject Payment</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text mb={4}>Please provide a reason for rejection:</Text>
              <Textarea
                placeholder="Enter reason for rejection..."
                value={reasonForRejection}
                onChange={(e) => setReasonForRejection(e.target.value)}
              />
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="red" onClick={handleConfirmReject} isLoading={approvePaymentMutation.isLoading}>
                Submit Rejection
              </Button>
              <Button variant="ghost" onClick={() => setIsRejectModalOpen(false)}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Modal for viewing results */}
        <Modal isOpen={isResultsModalOpen} onClose={() => setIsResultsModalOpen(false)}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Results</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              {selectedResults.length > 0 ? (
                selectedResults.map((result) => (
                  <Box key={result._id} mb={4}>
                    <Text><strong>User Name:</strong> {result.userId?.name}</Text>
                    <Text><strong>User Phone:</strong> {result.userId?.phoneNumber}</Text>
                    <Text><strong>Lot Name:</strong> {result.itemId?.name}</Text>
                    <Text><strong>Amount:</strong> {result.amount}</Text>
                    <Text><strong>Status:</strong> {result.status}</Text>
                  </Box>
                ))
              ) : (
                <Text>No results available</Text>
              )}
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="teal" onClick={() => setIsResultsModalOpen(false)}>
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </VStack>
    </Container>
  );
};

export default PaymentDetails;
